import React, { useState } from "react";
import { motion } from "framer-motion";
import { ButtonClose, ButtonPopup } from "../ui";
import CookieConsentModal from "../docs/CookieConsentModal";
import { useNavigate } from "react-router-dom";

const PoliticaPrivacidad: React.FC = () => {
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);

  const navigate = useNavigate();
  const handleClose = () => {
    navigate(-1);
  };
  return (
    <div
      className="w-full h-screen flex items-center justify-center px-4 py-10 bg-cover bg-center relative"
      style={{ backgroundImage: "url('/img/politicas/fondoLinkservs.png')" }}
    >
      {/* 🔹 Overlay */}
      <div className="absolute inset-0 bg-black/40 backdrop-blur-sm" />

      <motion.div
        className="relative z-10 w-[210mm] max-w-full max-h-[95vh] rounded-2xl border border-white/20 shadow-2xl bg-black/30 backdrop-blur-xs overflow-hidden"
        initial={{ opacity: 0, y: 20, scale: 0.95 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 0.5 }}
      >
        {/* 🔹 Contenido scrollable */}
        <div className="p-8 overflow-y-auto max-h-[95vh] text-white">
          {/* Botón cerrar */}
          <div className="flex justify-end mb-6">
            <ButtonClose onClick={handleClose} />
          </div>

          {/* Título */}
          <h1 className="text-4xl font-extrabold text-center mb-4 text-white">
            Política de Privacidad
          </h1>

          <p className="text-sm text-zinc-800 mb-6 text-center">
            <strong>Última actualización:</strong> 17 de abril del 2026
          </p>

          {/* Contenido */}
          <div className="space-y-6 leading-relaxed text-justify">
            <p>
              En <strong>CuadraNex</strong>, respetamos y protegemos tu
              privacidad. Esta Política de Privacidad tiene como objetivo
              informarte sobre cómo recopilamos, utilizamos, almacenamos y
              protegemos tu información personal cuando interactúas con nuestros
              servicios en línea y con nuestra plataforma de suscripción de
              pago.
            </p>

            <section>
              <h2 className="text-xl font-semibold mt-6 mb-2 text-zinc-800">
                1. Responsable del Tratamiento de Datos
              </h2>
              <ul className="list-disc ml-6 space-y-1">
                <li>
                  <strong>Empresa:</strong> CuadraNex
                </li>
                <li>
                  <strong>CIF:</strong> B-26925339
                </li>
                <li>
                  <strong>Dirección:</strong> c/ Oropesa nº 11, Yuncos (Toledo),
                  España
                </li>
                <li>
                  <strong>Teléfono:</strong> 925 00 41 05
                </li>
                <li>
                  <strong>Correo electrónico:</strong> cuadranex@cuadranex.com
                </li>
                <li>
                  <strong>Sitio web:</strong> www.linkservs.com
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mt-6 mb-2 text-zinc-800">
                2. Datos Personales que Recopilamos
              </h2>
              <ul className="list-disc ml-6 space-y-1">
                <li>
                  <strong>Datos que nos proporcionas directamente:</strong>{" "}
                  información de registro, datos de pago, datos de suscripción e
                  interacciones con el servicio.
                </li>
                <li>
                  <strong>Datos que obtenemos automáticamente:</strong>{" "}
                  dirección IP, tipo de navegador, cookies y tecnologías
                  similares.
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mt-6 mb-2 text-zinc-800">
                3. Finalidades del Tratamiento
              </h2>
              <ul className="list-disc ml-6 space-y-1">
                <li>Gestión de suscripciones y usuarios.</li>
                <li>Facturación y pagos.</li>
                <li>Soporte al cliente.</li>
                <li>Mejora de servicios y experiencia del usuario.</li>
                <li>
                  Marketing y promociones (si el usuario da su consentimiento).
                </li>
                <li>Cumplimiento de obligaciones legales.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mt-6 mb-2 text-zinc-800">
                4. Bases Legales del Tratamiento
              </h2>
              <ul className="list-disc ml-6 space-y-1">
                <li>Ejecución de un contrato.</li>
                <li>Cumplimiento de una obligación legal.</li>
                <li>Consentimiento del usuario.</li>
                <li>Intereses legítimos de la empresa.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mt-6 mb-2 text-zinc-800">
                5. Comunicación y Transferencias de Datos
              </h2>
              <p>
                No vendemos ni alquilamos tu información personal. Podemos
                compartir tus datos con proveedores de servicios, autoridades
                legales o regulatorias, siempre bajo contratos de
                confidencialidad y cumplimiento normativo.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mt-6 mb-2 text-zinc-800">
                6. Transferencias Internacionales
              </h2>
              <p>
                Si utilizamos proveedores fuera del Espacio Económico Europeo,
                garantizamos que tus datos estén protegidos mediante cláusulas
                contractuales estándar o mecanismos de adecuación reconocidos
                por la Unión Europea.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mt-6 mb-2 text-zinc-800">
                7. Periodo de Conservación
              </h2>
              <p>
                Conservamos tus datos personales únicamente durante el tiempo
                necesario para cumplir las finalidades para las que fueron
                recopilados o según lo exija la legislación aplicable.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mt-6 mb-2 text-zinc-800">
                8. Derechos del Usuario
              </h2>

              <p>
                Puedes ejercer tus derechos de acceso, rectificación, supresión,
                limitación, oposición y portabilidad de los datos escribiendo a:
                <strong> linkservs@linkserv.com</strong>.
              </p>

              {/* Eliminación de cuenta */}
              <div className="mt-5 rounded-xl border border-white/20 bg-white/10 backdrop-blur-sm p-5">
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                  <div>
                    <h3 className="text-lg font-semibold text-zinc-800 mb-1">
                      ¿Quieres eliminar tu cuenta?
                    </h3>

                    <p className="text-sm text-zinc-700">
                      Puedes solicitar la eliminación de tu cuenta de LinkServs
                      y de los datos personales asociados.
                    </p>
                  </div>

                  <button
                    type="button"
                    onClick={() => navigate("/eliminacion-cuenta")}
                    className="shrink-0 px-5 py-2.5 rounded-lg bg-white/90 text-zinc-900 font-semibold
                   shadow-md hover:bg-white hover:scale-[1.02]
                   transition-all duration-200"
                  >
                    Solicitar eliminación
                  </button>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-semibold mt-6 mb-2 text-zinc-800">
                9. Seguridad de los Datos
              </h2>
              <p>
                Aplicamos medidas técnicas y organizativas adecuadas para
                proteger tus datos contra el acceso no autorizado, la alteración
                o la pérdida accidental.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mt-6 mb-2 text-zinc-800">
                10. Modificaciones de esta Política
              </h2>
              <p>
                Nos reservamos el derecho a modificar esta Política de
                Privacidad. Cualquier cambio significativo será notificado a los
                usuarios antes de su entrada en vigor.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mt-6 mb-2 text-zinc-800">
                11. Contacto
              </h2>
              <p>
                Si tienes preguntas o solicitudes relacionadas con esta
                política, puedes contactarnos en:
              </p>
              <ul className="list-disc ml-6">
                <li>
                  <strong>Email:</strong> cuadranex@cuadranex.com
                </li>
                <li>
                  <strong>Teléfono:</strong> 925 00 41 05
                </li>
              </ul>
            </section>
          </div>

          {/* Botón inferior */}
          <div className="flex justify-center mt-10">
            <ButtonPopup onClick={handleClose}>Cerrar</ButtonPopup>
          </div>

          {/* Modal de cookies opcional */}
          {showPrivacyModal && (
            <CookieConsentModal onClose={() => setShowPrivacyModal(false)} />
          )}
        </div>
      </motion.div>
    </div>
  );
};

export default PoliticaPrivacidad;
